import { Flujo } from '../interfaces/flujo';


export abstract class FlujosPaso2Service {
  
  paso1Created: boolean;
  datosPersonales: Flujo;
  datosComercio: Flujo;
  configuracionProducto: Flujo;
  datosAdjuntos: Flujo;
  cuentaBancaria: Flujo;

  abstract setEdicionFalse();
}
